var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"meta-menu-button",attrs:{"id":_vm.id},on:{"click":function($event){return _vm.$emit('button-clicked', _vm.id)}}},[(_vm.showText)?_c('span',[_vm._v(_vm._s(_vm.text))]):_c('span')])}
var staticRenderFns = []

export { render, staticRenderFns }